// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import Image from '/react4xp/components/Image'
import Mask from '/react4xp/components/Mask'
import Balloon from '/react4xp/components/Balloon'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

// svg
import { GeneralPhone } from '/react4xp/components/Svg/Icons/General'

// prop types
interface ContactPhoneProps {
    section?: {
        paddingTop?: 'smaller' | 'small' | 'medium' | 'big' | 'none'
        paddingBottom?: 'smaller' | 'small' | 'medium' | 'big' | 'none'
    }
    title?: string
    phones?: Array<{
        text?: string
        phone: string
    }>
}

export default function ContactPhone({
    section,
    title,
    phones
}: ContactPhoneProps) {
    return (
        <Section
            bgColor='blue'
            paddingTop={section?.paddingTop}
            paddingBottom={section?.paddingBottom}
            className='contact-phone'
        >
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-10 offset-lg-1'>
                        <div className='contact-phone__wrapper'>

                            {isNonWhitespaceString(title) && (
                                <Balloon
                                    balloonColor='blue-dark'
                                    spacing='small'
                                    arrowSize='small'
                                    arrow='bottom-middle'
                                    balloonSide='left'
                                    arrowSide='right'
                                >
                                    <h2 className='h3 line-break white'>
                                        {title}
                                    </h2>
                                </Balloon>
                            )}

                            {phones && (
                                <Mask bgColor='white' className={clsx(title && 'has-title')}>

                                    <GeneralPhone />

                                    <ul>

                                        {phones.map((item, i) => (
                                            <li key={i}>
                                                
                                                {isNonWhitespaceString(item.text) && (
                                                    <p>
                                                        <b>
                                                            {item.text}:
                                                        </b>
                                                    </p>
                                                )}

                                                <a href={`tel:${item.phone}`} className='regular-link'>
                                                    {item.phone}
                                                </a>

                                            </li>
                                        ))}

                                    </ul>

                                </Mask>
                            )}

                        </div>
                    </div>
                </div>
            </div>
        </Section>
    )
}